import { NgIf, NgStyle } from '@angular/common';
import { AfterViewInit, Component, DestroyRef, ElementRef, Inject, OnDestroy, OnInit, Renderer2, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HammerModule } from '@angular/platform-browser';

import { ConfigProviderService, Renderer2UnsubscribeFunction } from '@casinocore/platform/core';
import { AppInfoConfig, DeviceService, ProductService, TrackingService } from '@frontend/vanilla/core';
import { PageMatrixComponent } from '@frontend/vanilla/features/content';
import * as Hammer from 'hammerjs';
import { Subscription } from 'rxjs';

import { InstagramStoryProgressBarComponent } from '../instagram-story-progress-bar/instagram-story-progress-bar.component';
import { InstaPromoModel } from '../shared/model/insta-promo.model';
import { UserActionService } from '../shared/services/user-action.service';

@Component({
    selector: 'cc-instagram-story-modal',
    templateUrl: 'instagram-story-modal.component.html',
    imports: [NgStyle, PageMatrixComponent, InstagramStoryProgressBarComponent, NgIf, HammerModule],
})
export class InstagramStoryModalComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('instaStoryContainer', { read: ElementRef }) scrollContainer: ElementRef;
    @ViewChild('swipeupContentFrame', { read: ElementRef }) swipeUpContentContainer: ElementRef;
    activePromoIndex: number;
    activePromoStoryIndex: number;
    activePromo: InstaPromoModel;
    activeStoryPath: string;
    enableSwipeUp: boolean;
    swipeUpStoryContentPath: string;
    displaySwipeUp: boolean;
    displayDownArrow: boolean;
    closebtnClr: string;
    Promotionpage_title: string;
    swipeupClr: string;
    promotionTitleClr: string;
    promotionTitleBgClr: string;
    targetPromoId: string;
    targetPromoType: string;
    targetPromoStatus: string;
    changePromoStatusObservable: Subscription;
    versionedList: any;
    displaySwipeUpContent: boolean;
    swipeupText: string;
    swipeupTextColor: string;
    disableTap: boolean;
    gamingStoriesClientConfig: any;
    currentProduct: string;
    private hammerManager!: HammerManager;
    private hammerManagerSwipeUp!: HammerManager;
    private destroyRef = inject(DestroyRef);

    private rendererEvents: Renderer2UnsubscribeFunction[] = [];

    constructor(
        public dialogRef: MatDialogRef<InstagramStoryModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private userActionService: UserActionService,
        private tracking: TrackingService,
        private deviceservice: DeviceService,
        private configProviderService: ConfigProviderService,
        private productService: ProductService,
        private appInfoConfig: AppInfoConfig,
        private renderer: Renderer2,
    ) {}

    ngOnInit() {
        this.gamingStoriesClientConfig = this.configProviderService.provideGamingStoriesConfig();
        this.resumeStory();
        this.setActivePromoAndStory(this.data.activePromoIndex, 0);
        this.trackGamingStories('OverlayLaunched', this.activePromoIndex, this.activePromoStoryIndex);
        this.closebtnClr = this.data.storyData.sharedList.closebtnClr;
        this.Promotionpage_title = this.data.storyData.versionedList.Promotionpage_title;
        this.swipeupClr = this.data.storyData.sharedList.swipeupClr;
        this.swipeupText = this.data.storyData.versionedList.swipeupText;
        this.swipeupTextColor = this.data.storyData.sharedList.swipeupTextColor;
        this.promotionTitleClr = this.data.storyData.sharedList.promotionTitleClr;
        this.promotionTitleBgClr = this.data.storyData.sharedList.promotionTitleBgClr;
        this.versionedList = this.data.storyData.versionedList;
        this.changePromoStatusObservable = this.userActionService.changePromoStatusObservable
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((promoStatusObject: any) => {
                if (promoStatusObject) {
                    this.data.storyData.instaPromoList[promoStatusObject.activePromoIndex].instaStoryContentModel[
                        promoStatusObject.activePromoStoryIndex
                    ].targetPromoStatus = promoStatusObject.promoStatus;
                }
            });
        this.currentProduct = this.productService.isSingleDomainApp ? this.productService.current.name : this.appInfoConfig?.product?.toLowerCase();
    }

    storyCompletionEventFromProgressBar(event: any) {
        let activePromoIndex = event.activePromoIndex;
        let activePromoStoryIndex = event.activePromoStoryIndex;
        if (activePromoIndex + 1 < this.data.storyData.instaPromoList.length) {
            if (activePromoStoryIndex + 1 < this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel.length) {
                this.goToNextStory(activePromoIndex, activePromoStoryIndex);
            } else {
                this.goToNextPromo(activePromoIndex);
            }
        } else if (activePromoIndex + 1 == this.data.storyData.instaPromoList.length) {
            if (activePromoStoryIndex + 1 < this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel.length) {
                this.goToNextStory(activePromoIndex, activePromoStoryIndex);
            } else {
                this.closeModal();
            }
        } else {
            this.closeModal();
        }
        this.trackGamingStories('AutoSwitch', activePromoIndex, activePromoStoryIndex);
    }

    setActivePromoAndStory(promoIndex: number, storyIndex: number) {
        this.activePromoIndex = promoIndex;
        this.activePromoStoryIndex = storyIndex;
        this.activePromo = this.data.storyData.instaPromoList[this.activePromoIndex];
        this.activeStoryPath =
            this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel[this.activePromoStoryIndex].mainStoryContentPath;
        this.enableSwipeUp =
            this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel[this.activePromoStoryIndex].enableSwipeUp;
        this.swipeUpStoryContentPath =
            this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel[this.activePromoStoryIndex].swipeUpContentPath;
        this.targetPromoId =
            this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel[this.activePromoStoryIndex].targetPromoId;
        this.targetPromoType =
            this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel[this.activePromoStoryIndex].targetPromoType;
        this.targetPromoStatus =
            this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel[this.activePromoStoryIndex].targetPromoStatus;
        this.setViewedStory(promoIndex, storyIndex);
        if (this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel.length == this.activePromoStoryIndex + 1) {
            this.setViewedPromo(promoIndex);
        }
        this.resetDisplayArrows(this.enableSwipeUp);
        this.userActionService.storyHasVideo = false; //resetting video present flag to false
        setTimeout(() => {
            const playNowCTA = this.scrollContainer?.nativeElement?.querySelector('.more-info-btn');
            if (!playNowCTA) {
                return;
            }

            this.rendererEvents.push(
                this.renderer.listen(playNowCTA, 'click', () => {
                    this.closeModal();
                }),
            );
        }, this.gamingStoriesClientConfig.gameLaunchSetTimeOut);
    }

    toggleDisplayArrows() {
        this.displaySwipeUp = !this.displaySwipeUp;
        this.displayDownArrow = !this.displayDownArrow;
    }

    goToNextPromo(currentPromoIndex: number) {
        this.setActivePromoAndStory(currentPromoIndex + 1, 0);
    }

    goToPreviousPromo(currentPromoIndex: number) {
        this.setActivePromoAndStory(currentPromoIndex - 1, 0);
    }

    goToNextStory(currentPromoIndex: number, currentStoryIndex: number) {
        this.setActivePromoAndStory(currentPromoIndex, currentStoryIndex + 1);
    }

    goToPreviousStory(currentPromoIndex: number, currentStoryIndex: number) {
        this.setActivePromoAndStory(currentPromoIndex, currentStoryIndex - 1);
    }

    closeModal($event: any = null): void {
        this.userActionService.pauseVideo();
        this.tracking.triggerEvent('Event.Tracking', {
            'component.CategoryEvent': 'teaser - embedded video',
            'component.LabelEvent': 'stories',
            'component.ActionEvent': 'click',
            'component.PositionEvent': this.data.storyData.instaPromoList[this.activePromoIndex].promoItemId,
            'component.LocationEvent':
                this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel[this.activePromoStoryIndex].mainStoryItemName,
            'component.EventDetails': 'close',
            'component.URLClicked': 'not applicable',
        });
        this.setViewedStory(this.activePromoIndex, this.activePromoStoryIndex);
        this.setViewedPromo(this.activePromoIndex);
        $event && $event.stopImmediatePropagation();
        this.dialogRef.close(this.data.storyData);
    }

    onRightSwipe() {
        this.userActionService.pauseVideo();
        this.setPromoForRightSwipe();
    }

    onLeftSwipe() {
        this.userActionService.pauseVideo();
        this.setPromoForLeftSwipe();
    }

    onTap(evt: any) {
        const targetElement = evt.target as HTMLElement;
        if (
            targetElement.closest('.close.theme-ex') ||
            targetElement.closest('.toggle-mute-button.theme-sound-loud') ||
            targetElement.closest('.toggle-mute-button.theme-sound-mute')
        ) {
            return;
        }
        let instaStoryPageMatrixConatiner = document.getElementById('instaStoryPageMatrixConatiner')!;
        let tapHeightLimit = instaStoryPageMatrixConatiner?.offsetHeight / 4.5;
        if (tapHeightLimit < evt.changedPointers[0].clientY) {
            if (this.disableTap) {
                return;
            }
            this.disableTap = true;
            if (this.userActionService.storyHasVideo) {
                let video = <HTMLVideoElement>document.getElementById('casino-promoinstastory-video');
                let stream: HTMLMediaElement = {} as HTMLMediaElement;
                if (!video) stream = document.querySelector('#casino-promoinstastory-cmsvideo stream') as HTMLMediaElement;
                if (video && (video.readyState == 3 || video.readyState == 4) && video.currentTime >= 1) {
                    video.pause();
                    this.processOnTap(evt);
                } else if (stream && stream.currentTime >= 1) {
                    stream.pause();
                    this.processOnTap(evt);
                } else {
                    this.disableTap = false;
                }
            } else {
                this.processOnTap(evt);
            }
        }
    }

    processOnTap(evt: any) {
        let instaStoryPageMatrixConatiner = document.getElementById('instaStoryPageMatrixConatiner')!;
        let clickXPosition = evt.changedPointers[0].clientX - (window.innerWidth - instaStoryPageMatrixConatiner?.offsetWidth) / 2;
        if (clickXPosition < instaStoryPageMatrixConatiner.offsetWidth / 5) {
            this.setPromoAndStoryForLeftTap();
        } else if (clickXPosition > 4 * (instaStoryPageMatrixConatiner.offsetWidth / 5)) {
            this.setPromoAndStoryForRightTap();
        } else {
            this.userActionService.playVideo(); //if left tap and right tap are not happening and video is paused
        }
        this.disableTap = false;
    }

    setPromoForLeftSwipe() {
        if (this.activePromoIndex + 1 < this.data.storyData.instaPromoList.length) {
            this.goToNextPromo(this.activePromoIndex);
        } else {
            this.closeModal();
        }
    }

    setPromoForRightSwipe() {
        if (this.activePromoIndex > 0) {
            this.goToPreviousPromo(this.activePromoIndex);
        } else {
            this.closeModal();
        }
    }

    setPromoAndStoryForLeftTap() {
        let activePromoIndex = this.activePromoIndex;
        let activePromoStoryIndex = this.activePromoStoryIndex;
        if (this.activePromoIndex == 0 && this.activePromoStoryIndex == 0) {
            this.userActionService.playVideo();
        } else if (this.activePromoStoryIndex > 0) {
            this.goToPreviousStory(this.activePromoIndex, this.activePromoStoryIndex);
        } else if (this.activePromoStoryIndex == 0) {
            this.goToPreviousPromo(this.activePromoIndex);
        }
        this.trackGamingStories('LeftTap', activePromoIndex, activePromoStoryIndex);
    }

    setPromoAndStoryForRightTap() {
        let activePromoIndex = this.activePromoIndex;
        let activePromoStoryIndex = this.activePromoStoryIndex;
        if (
            this.activePromoIndex + 1 == this.data.storyData.instaPromoList.length &&
            this.activePromoStoryIndex + 1 == this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel.length
        ) {
            this.userActionService.playVideo();
        } else if (this.activePromoStoryIndex + 1 < this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel.length) {
            this.goToNextStory(this.activePromoIndex, this.activePromoStoryIndex);
        } else if (this.activePromoStoryIndex + 1 == this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel.length) {
            this.goToNextPromo(this.activePromoIndex);
        }
        this.trackGamingStories('RightTap', activePromoIndex, activePromoStoryIndex);
    }

    ngAfterViewInit() {
        if (this.gamingStoriesClientConfig.enableOverlayMobileSearchTopPosition) {
            this.instagramOverlayTopAllignment();
        }
        if (this.scrollContainer) {
            this.hammerManager = new Hammer.Manager(this.scrollContainer.nativeElement);

            this.hammerManager.add(new Hammer.Swipe({ direction: Hammer.DIRECTION_HORIZONTAL }));
            this.hammerManager.add(new Hammer.Pan({ direction: Hammer.DIRECTION_VERTICAL }));
            this.hammerManager.add(new Hammer.Press());
            this.hammerManager.add(new Hammer.Tap());

            this.hammerManager.on('swipeleft', () => this.onLeftSwipe());
            this.hammerManager.on('swiperight', () => this.onRightSwipe());
            this.hammerManager.on('panup', () => this.swipeToBottom());
            this.hammerManager.on('pandown', () => this.swipeToTop());
            this.hammerManager.on('press', () => this.pauseStory());
            this.hammerManager.on('pressup', () => this.resumeStory());
            this.hammerManager.on('tap', (event) => this.onTap(event));

            if (this.swipeUpContentContainer) {
                this.hammerManagerSwipeUp = new Hammer.Manager(this.swipeUpContentContainer.nativeElement);
                this.hammerManagerSwipeUp.add(new Hammer.Pan({ direction: Hammer.DIRECTION_VERTICAL }));
                this.hammerManagerSwipeUp.on('pandown', () => this.swipeToTop());
            }
        }
    }

    swipeToBottom() {
        if (this.displaySwipeUp && this.swipeUpStoryContentPath) {
            this.displaySwipeUpContent = true;
            this.toggleDisplayArrows();
            let swipeUpContent = this.swipeUpContentContainer.nativeElement;
            this.userActionService.pauseVideo();
            this.pauseStory();
            if (!this.deviceservice.isiOS) {
                swipeUpContent.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }
            if (this.deviceservice.isiOS) {
                swipeUpContent.scrollIntoView(true);
            }
        }
    }

    swipeToTop() {
        this.displaySwipeUpContent = false;
        this.toggleDisplayArrows();
        let scrollContent = this.scrollContainer.nativeElement;
        this.resumeStory();
        if (!this.deviceservice.isiOS) {
            scrollContent.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        }
        if (this.deviceservice.isiOS) {
            scrollContent.scrollIntoView(true);
        }
    }

    resetDisplayArrows(enableSwipeUp: boolean) {
        this.displaySwipeUp = enableSwipeUp;
        this.displayDownArrow = false;
    }

    pauseStory() {
        this.userActionService.pauseStory(true);
    }

    resumeStory() {
        this.userActionService.pauseStory(false);
    }

    setViewedStory(activePromoIndex: number, activePromoStoryIndex: number) {
        this.data.storyData.instaPromoList[activePromoIndex].instaStoryContentModel[activePromoStoryIndex].viewed = true;
    }

    setViewedPromo(activePromoIndex: number) {
        let activePromo = this.data.storyData.instaPromoList[activePromoIndex];
        let promoHasNotViewedStory: boolean = false;
        activePromo.instaStoryContentModel.forEach((story: any) => {
            if (!story.viewed) {
                promoHasNotViewedStory = true;
            }
        });
        if (!promoHasNotViewedStory) {
            this.data.storyData.instaPromoList[activePromoIndex].viewed = true;
        }
    }

    trackGamingStories(action: string, sourcePromoIndex: number, sourcePromoStoryIndex: number) {
        if (action == 'OverlayLaunched') {
            this.tracking.triggerEvent('Event.Tracking', {
                'component.CategoryEvent': 'teaser - embedded video',
                'component.LabelEvent': 'stories',
                'component.ActionEvent': 'load',
                'component.PositionEvent': this.activePromoIndex + 1,
                'component.LocationEvent':
                    this.data?.storyData?.instaPromoList[sourcePromoIndex]?.instaStoryContentModel[sourcePromoStoryIndex]?.mainStoryItemName,
                'component.EventDetails': this.data?.storyData?.instaPromoList[sourcePromoIndex]?.promoItemId,
                'component.URLClicked': 'not applicable',
            });
        } else if (action == 'AutoSwitch') {
            this.tracking.triggerEvent('Event.Tracking', {
                'component.CategoryEvent': 'teaser - embedded video',
                'component.LabelEvent': 'stories',
                'component.ActionEvent': 'click',
                'component.PositionEvent':
                    this.data.storyData.instaPromoList[sourcePromoIndex].promoItemId +
                    '-' +
                    this.data.storyData.instaPromoList[sourcePromoIndex].instaStoryContentModel[sourcePromoStoryIndex].mainStoryItemName,
                'component.LocationEvent':
                    this.data.storyData.instaPromoList[this.activePromoIndex].promoItemId +
                    '-' +
                    this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel[this.activePromoStoryIndex].mainStoryItemName,
                'component.EventDetails': 'auto',
                'component.URLClicked': 'not applicable',
            });
        } else if (action == 'LeftTap') {
            this.tracking.triggerEvent('Event.Tracking', {
                'component.CategoryEvent': 'teaser - embedded video',
                'component.LabelEvent': 'stories',
                'component.ActionEvent': 'click',
                'component.PositionEvent':
                    this.data.storyData.instaPromoList[sourcePromoIndex].promoItemId +
                    '-' +
                    this.data.storyData.instaPromoList[sourcePromoIndex].instaStoryContentModel[sourcePromoStoryIndex].mainStoryItemName,
                'component.LocationEvent':
                    this.data.storyData.instaPromoList[this.activePromoIndex].promoItemId +
                    '-' +
                    this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel[this.activePromoStoryIndex].mainStoryItemName,
                'component.EventDetails': 'left',
                'component.URLClicked': 'not applicable',
            });
        } else if (action == 'RightTap') {
            this.tracking.triggerEvent('Event.Tracking', {
                'component.CategoryEvent': 'teaser - embedded video',
                'component.LabelEvent': 'stories',
                'component.ActionEvent': 'click',
                'component.PositionEvent':
                    this.data.storyData.instaPromoList[sourcePromoIndex].promoItemId +
                    '-' +
                    this.data.storyData.instaPromoList[sourcePromoIndex].instaStoryContentModel[sourcePromoStoryIndex].mainStoryItemName,
                'component.LocationEvent':
                    this.data.storyData.instaPromoList[this.activePromoIndex].promoItemId +
                    '-' +
                    this.data.storyData.instaPromoList[this.activePromoIndex].instaStoryContentModel[this.activePromoStoryIndex].mainStoryItemName,
                'component.EventDetails': 'right',
                'component.URLClicked': 'not applicable',
            });
        }
    }
    instagramOverlayTopAllignment() {
        if (document.querySelector('.content-messages-header-top .content-message-container')) {
            let insta_olay: HTMLElement = document.querySelector('.casino-mobile-stories .cdk-overlay-container')!;
            if (insta_olay) {
                insta_olay.style.top = document.querySelector('.content-messages-header-top .content-message-container')?.clientHeight + 'px';
            }
        }
    }

    ngOnDestroy() {
        if (this.changePromoStatusObservable) {
            this.changePromoStatusObservable.unsubscribe();
        }
        if (this.hammerManager) {
            this.hammerManager.destroy();
        }
        if (this.hammerManagerSwipeUp) {
            this.hammerManagerSwipeUp.destroy();
        }

        for (const unsubscribeFn of this.rendererEvents) {
            unsubscribeFn();
        }
        this.rendererEvents = [];
    }
}
